import { useEffect } from "react";

export default function useClickAway(componentRef, onClickAway) {
  useEffect(() => {
    const clickAwayHandler = (e) => {
      if (componentRef.current && !componentRef.current.contains(e.target)) {
        onClickAway();
      }
    };

    const timerId = setTimeout(() => {
      document.addEventListener("click", clickAwayHandler);
    }, 1);

    return () => {
      clearTimeout(timerId);
      document.removeEventListener("click", clickAwayHandler);
    };
  }, [componentRef, onClickAway]);
}